import React, { useState, useEffect } from 'react';
import './GameTeamSteps.css'; // Import your CSS file for styling
import GameContentProvider from '../providers/GameContentProvider';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';


import customMarkerIcon from '../assets/marker.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import useTranslation

const MapOverlay = ({ closeOverlay }) => {
    const { t } = useTranslation(); // Initialize useTranslation

    useEffect(() => {
        const map = L.map('map').setView([42.6977, 23.3219], 13);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

        // Create a custom marker icon
        const customIcon = L.icon({
            iconUrl: customMarkerIcon,
            iconSize: [32, 32], // Adjust the size of the icon as needed
            iconAnchor: [16, 32],
            popupAnchor: [0, -32],
        });

        // Add a marker
        L.marker([42.6977, 23.3219], { icon: customIcon }).addTo(map);

        // You can customize this further based on your needs
    }, []);

    return (
        <div>
            <h2>{t('map_overlay')}</h2>
            <div id="map" style={{ height: '80vh', width: "100vh" }}></div>
            <button onClick={() => closeOverlay('map')}>Close</button>
        </div>
    );
};


const GameTeamSteps = () => {
    const { t, i18n } = useTranslation(); // Initialize useTranslation

    const [inputValue, setInputValue] = useState('');
    const [overlayType, setOverlayType] = useState(null);
    const [overlayVisible, setOverlayVisible] = useState(false);

    const [step, setStep] = useState(null);
    const [gameId, setGameId] = useState(null);
    const [stepId, setStepId] = useState(null);
    const [hint_used, setHintUsed] = useState(0);
    const [teamGameId, setTeamGameId] = useState(null);
    const [ranking, setRanking] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();


    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    }


    const handleIconClick = async (overlay) => {
        // Handle icon click logic
        // For example, you can set the overlay type and visibility here
        setOverlayType(overlay);
        setOverlayVisible(true);

        // Fetch ranking data only when 'ranking' is clicked
        if (overlay === 'ranking') {
            setLoading(true); // Start the loading state for ranking
            try {
                const gameContentProvider = new GameContentProvider();
                const rankingData = await gameContentProvider.getRanking(teamGameId); // Fetch ranking
                setRanking(rankingData); // Set ranking state with fetched data
            } catch (error) {
                console.error('Error fetching ranking:', error);
            } finally {
                setLoading(false); // Stop loading after data is fetched
            }
        }else if(overlay === "hints"){
            setHintUsed(1);
        }
    };

    const closeOverlay = (overlay) => {
        // Close the overlay
        setOverlayVisible(false);

        if (overlay == "correct" || overlay == "final") {
            //Start next step
            const newData = {
                game: gameId,
                step: stepId + 1,
                team_game_id: teamGameId,
            };

            //Report step has been completed
            const gameContentProvider = new GameContentProvider();
            let token;
            token = localStorage.getItem('token');
            if (!token) {
                console.log("kur2");
                token = localStorage.getItem('guest_token');
            }

            console.log("Current token: " + token);
            const result = gameContentProvider.teamStepCompleted(stepId, token, teamGameId, hint_used);

            if (result) {
                console.log("Open next step for: ", newData);

                if (overlay == "correct") {
                    //Not final step. Open next step
                    navigate(location.pathname, { state: newData, replace: true });
                } else {
                    //Final step
                    navigate("/game-overview", { state: newData, replace: true });
                }


            } else {
                console.log("Error completing the step");
            }

        }
    };

    const handleNextStep = (overlay) => {
        console.log(inputValue);
        console.log(step.answer);

        if (!step.answer.some(item => item.toLowerCase().trim() === inputValue.toLowerCase().trim())) {
            //Code is incorrect
            handleIconClick('wrong');
        } else if (step.finalStep == 1) {
            // This is the last step
            //Start screen 
            handleIconClick('final');
            console.log("Final Step - Congratulations");
        } else {
            setHintUsed(0);
            handleIconClick('correct');

        }
    };

    useEffect(() => {
        const handleMessage = (event) => {
            // Ensure the message is from a trusted source (optional security check)
            // You may want to check the event.origin property

            const data = event.data;
            console.log(data);
            //console.log(data);
            if (data && data.game && data.step) {
                console.log(data);
                setGameId(data.game);
                setStepId(data.step);
                setTeamGameId(data.team_game_id);
                // Log each parameter individually
                console.log('game:', data.game);
                console.log('step:', data.step);
                console.log('team_game_id:', data.team_game_id);


            }

        };
        window.addEventListener('message', handleMessage);


        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [gameId]);


    useEffect(() => {
        const { game, step, team_game_id } = location.state || {};
        if (game) {
            setGameId(game);
        }
        if (step) {
            setStepId(step);
        }

        if (team_game_id) {
            setTeamGameId(team_game_id);
        }

    }, [location.state]);



    useEffect(() => {

        const fetchData = async () => {
            console.log("fetchData");
            try {
                const gameContentProvider = new GameContentProvider();
                const stepsDetails = await gameContentProvider.getStepDetails(gameId, stepId, (i18n.language || 'bg').substring(0, 2));
                console.log(stepsDetails);
                setStep(stepsDetails[0]);
            } catch (error) {
                console.error('Error fetching game details:', error);
                // Handle error as needed
            }
        };

        if (gameId != null && gameId != undefined && stepId != null && stepId != undefined && teamGameId != null && teamGameId != undefined) {
            fetchData();
        } else {
            console.log("fetchData null");
            console.log(gameId);
            console.log(stepId);
            console.log(teamGameId);
            console.log(step);
        }

    }, [gameId, stepId, teamGameId, i18n.language]);


    if (!step) {
        return <div>Loading...</div>;
    }

    return (

        <div className="your-component">
            {/* Background image */}


            {/* Content container */}
            <div className="content-container">
                {/* Text description */}
                <h1>{step.text}</h1>


                {/* Input field and button centered at the bottom */}
                <div className="input-container">
                    <input
                        type="text"
                        placeholder="Enter something"
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                    <button onClick={() => handleNextStep()}>{t('submit')}</button>
                </div>

                {/* Icons on the right side */}
                <div className="icon-container">
                    {/* Icon 1 */}
                    <div className="icon icon1" onClick={() => handleIconClick('hints')}></div>

                    {/* Icon 2 */}
                    <div className="icon icon2" onClick={() => handleIconClick('map')}></div>

                    <div className="icon icon3" onClick={() => handleIconClick('ranking')}></div>
                </div>

                {/* Overlay view */}
                {overlayVisible && (
                    <div className={`overlay ${overlayType === 'map' ? 'map-overlay' : ''}`}>
                        <div className="overlay-content">
                            {overlayType === 'hints' && (
                                <div>
                                    <h2>{t('hints')}</h2>
                                    <p2>{step.hint1}</p2>
                                    <br/>
                                    <button onClick={() => closeOverlay("hints")}>{t('close')}</button>
                                </div>
                            )}

                            {overlayType === 'ranking' && (
                                <div>
                                    <h2>{t('ranking_title')}</h2>
                                    {loading ? (
                                        <p>{t('loading')}</p>
                                    ) : ranking ? (
                                        <div>
                                            <table style={{ width: '100%' }}> {/* Set table width to 100% */}
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '10%', textAlign: 'left' }}>{t('')}</th> {/* Rank column width */}
                                                        <th style={{ width: '45%', textAlign: 'left' }}>{t('team_name2')}</th> {/* Team name column width */}
                                                        <th style={{ width: '45%' }}>{t('total_points')}</th> {/* Total points column width */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ranking.map((team, index) => (
                                                        <tr key={index}>
                                                            <td style={{ textAlign: 'left' }}>{index + 1}</td> {/* Rank number */}
                                                            <td style={{ textAlign: 'left' }}>{team.team_name}</td> {/* Team name */}
                                                            <td>{team.total_points}</td> {/* Total points */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>


                                    ) : (
                                        <p>{t('no_data')}</p>
                                    )}
                                    <button onClick={() => closeOverlay('ranking')}>
                                        {t('close')}
                                    </button>
                                </div>
                            )}

                            {overlayType === 'map' && <MapOverlay closeOverlay={closeOverlay} />}

                            {overlayType === 'wrong' && (
                                <div>
                                    <h2>{t('code_is_incorrect')}</h2>
                                    <button onClick={() => closeOverlay("wrong")}>{t('close')}</button>
                                </div>
                            )}

                            {overlayType === 'correct' && (
                                <div>
                                    <h2>{t('correct')} !</h2>
                                    <button onClick={() => closeOverlay("correct")}>{t('close')}</button>
                                </div>
                            )}

                            {overlayType === 'final' && (
                                <div>
                                    <h2>{t('correct')} !</h2>
                                    <button onClick={() => closeOverlay("final")}>{t('close')}</button>
                                </div>
                            )}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );

};

export default GameTeamSteps;




